export const LegalConsentKeys = Object.freeze({
  IS_LEGITIMATE_INTEREST: 'isLegitimateInterest',
  COMMUNICATION_CONSENT_TEXT: 'communicationConsentText',
  COMMUNICATION_CONSENT_CHECKBOXES: 'communicationConsentCheckboxes',
  PROCESSING_CONSENT_TYPE: 'processingConsentType',
  PROCESSING_CONSENT_TEXT: 'processingConsentText',
  PROCESSING_CONSENT_CHECKBOX_LABEL: 'processingConsentCheckboxLabel',
  PROCESSING_CONSENT_FOOTER_TEXT: 'processingConsentFooterText',
  PRIVACY_POLICY_TEXT: 'privacyPolicyText',
  SUBSCRIPTION_TYPES: 'legitimateInterestSubscriptionTypes',
  LAWFUL_BASIS: 'legitimateInterestLegalBasis'
});
export default LegalConsentKeys;